"use client";

import { MouseEvent, useCallback } from "react";
import { useLanguage } from "@/utils/LanguageContext";

const TELEGRAM_URL = "https://t.me/Invtrondaogroup";

interface GetInvolvedButtonProps {
  className?: string;
  onClick?: () => void;
}

const GetInvolvedButton = ({
  className = "",
  onClick,
}: GetInvolvedButtonProps) => {
  const { t } = useLanguage();

  const handleClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.currentTarget.blur();
    onClick?.();
  }, [onClick]);

  return (
    <div className={`get-involved-wrap ${className}`.trim()}>
      <a
        href={TELEGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="ts-buy-btn get-involved-btn get-involved-glow"
        onClick={handleClick}
      >
        {t("Click Here to Contribute!")}
      </a>
      <style jsx>{`
        .get-involved-wrap {
          display: flex;
          justify-content: center;
          margin-top: clamp(28px, 4vw, 44px);
        }

        .get-involved-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: min(320px, 92vw);
          min-height: 52px;
          font-weight: 700;
          text-align: center;
        }
      `}</style>
    </div>
  );
};

export default GetInvolvedButton;
